import AssetPreview from './AssetPreview';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ConnectedCarouselAssetPreview(props) {
  return /*#__PURE__*/_jsx(AssetPreview, Object.assign({}, props));
}